export function scrollToUnlockPanel() {
  document.getElementById('analysis-unlock-panel')?.scrollIntoView({
    behavior: 'smooth',
    block: 'start',
  });
}
